<div class="row d-flex justify-content-end container-style px-2 py-1" *ngIf="!isOpened">
  <div class="col-auto pt-1 pb-1">
    <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [severity]="'success'" [variant]="undefined"
      [icon]="'pi pi-plus'" [width]="'5.5rem'" (onClick)="createStorePrice()"></app-custom-button>
    <app-custom-modal #storePriceRegisterModal [label]="'Precios por Bodega - Captura'"
      [header]="'Precios por Bodega - Captura'" [inputs$]="inputsForRegisterModals$" [width]="'50rem'"
      [children]="componentRegisterModal" (params)="reloadList($event.reload)" hidden>
    </app-custom-modal>
  </div>
</div>
<div class="container-style mt-2" *ngIf="!isOpened">
  <app-custom-table [showImport]="true" [showExport]="true" [showRecover]="true" [headers]="storeHeader"
    [data]="storeData" [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'store-price'"
    (onRecoverData)="getAllStorePricesWithPagination()" (onPageChange)="onPageChange($event)"
    (onFilterChange)="onFilterChange($event)" (onImport)="onImport()" (onExport)="onExport()"
    (onAction)="onAction($event)" (onFilterChange)="onTableFilterChange($event)">
  </app-custom-table>
</div>
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>
<app-custom-modal #storePriceImportModal [label]="'Importar Precios por Bodega'" [width]="'40rem'"
  [header]="'Importar Precios por Bodega'" [children]="componentStorePriceImportModal"
  (params)="reloadList($event.reload)" hidden>
</app-custom-modal>